import Phaser from 'phaser';

export default class FinaleScene extends Phaser.Scene {
  constructor() {
    super('FinaleScene');

  }
  async create() {
    this.add.text(100, 150, 'All 3 friends are free! You win!', { fontSize: '32px', fill: '#fff' });
    if(location.hostname !== "localhost") this.submitScore();

    // Submit final game completion data
    const finaleData = {
        totalFriendsRescued: 5,
        totalTimeSpent: 900,
        completionTime: new Date().toISOString()
    };

    await window.sessionManager.submitFinaleChallenge(finaleData);

    // Get complete session summary
    const summary = await window.sessionManager.getSessionSummary();
    console.log('Complete game session:', summary);
  }
  submitScore() {
    console.log("sending score to server...");

    if(!!window.sessionId && window.sessionId !== "0") {
      fetch(`https://api.mediamasters.nl/extra-game/session-result?sessionId=${window.sessionId}`)
      .then(response => response.json())
      .then(data => {
        console.log('Score submitted successfully:', data);
        // window.sessionManager.end();
      })
      .catch((error) => {
        console.error('Error submitting score:', error);
        // window.sessionManager.end();
      })
      .finally(() => { 
        window.sessionManager.end(); 
      });
    } else {
      console.log("No sessionId found, not sending score to server");
    }
  }
}
